import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Institutions',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'sr.actions.save-external-institution',
            },
          },
          {
            '{}': {
              alias: 'sr.external-institutions.delete-institution',
            },
          },
        ],
      },
      content: {
        '{}': {
          count: {
            '`': {
              selection: {
                '#': {
                  '@': 'institutions',
                },
              },
              subqueries: {
                institutions: {
                  target: 'ent:!ext_institutions:!institution',
                },
              },
            },
          },
          query: {
            '`': {
              sort: {
                '{}': {
                  by: {
                    '@.': '!code',
                  },
                },
              },
              target: 'ent:!ext_institutions:!institution',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      ein: {
                        '{}': {
                          value: {
                            '@.': '!ein',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'ein',
                              },
                              recordId: {
                                '@.': '!ein',
                              },
                            },
                          },
                        },
                      },
                      uei: {
                        '{}': {
                          value: {
                            '@.': '!uei',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'uei',
                              },
                              recordId: {
                                '@.': '!uei',
                              },
                            },
                          },
                        },
                      },
                      code: {
                        '{}': {
                          value: {
                            '@.': '!code',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'code',
                              },
                              recordId: {
                                '@.': '!code',
                              },
                            },
                          },
                        },
                      },
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'name',
                              },
                              recordId: {
                                '@.': '!name',
                              },
                            },
                          },
                        },
                      },
                      type: {
                        '{}': {
                          value: {
                            '@.': '!type',
                          },
                        },
                      },
                      address: {
                        '{}': {
                          value: {
                            '@.': '!address',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'address',
                              },
                              recordId: {
                                '@.': '!address',
                              },
                            },
                          },
                        },
                      },
                      sam_name: {
                        '{}': {
                          value: {
                            '@.': '!sam_name',
                          },
                          record: {
                            '{}': {
                              entityId: {
                                '@_': 'sam_name',
                              },
                              recordId: {
                                '@.': '!sam_name',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                  onEdit: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              widget: {
                                '{}': {
                                  alias:
                                    'sr.external-institutions.widgets.edit-external-institution',
                                },
                              },
                              variables: {
                                '{}': {
                                  externalInstitutionId: {
                                    '@.': '!id',
                                  },
                                },
                              },
                            },
                          },
                          operation: 'ui.modal',
                        },
                      },
                    },
                  },
                  onDelete: {
                    '{}': {
                      action: {
                        '{}': {
                          alias: 'sr.external-institutions.delete-institution',
                        },
                      },
                      confirm: {
                        '{}': {
                          title: 'Delete institution',
                          message:
                            'Are you sure that you want to delete institution?',
                        },
                      },
                      variables: {
                        '{}': {
                          externalInstitutionId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'code',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!code',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'name',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!name',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'address',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!address',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'ein',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!ein',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'uei',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!uei',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'sam_name',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!sam_name',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'type',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!ext_institutions#!institution:!type',
                    },
                  },
                },
              },
            ],
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias:
                            'sr.external-institutions.widgets.edit-external-institution',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
        },
      },
    },
  },
}
